export default "__VITE_ASSET__BQGOpzBm__"